import { NavigateFunction } from 'react-router-dom';
import { NavigateLink } from '@/components/navigate/NavigateLinks';

export const customerServicePageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [{ label: 'Inicio', onClick: () => navigate('/') }];

export const childrenCustomerServicePageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...customerServicePageBreadcrumbs(navigate),
  { label: 'Atención al Cliente', onClick: () => navigate('/atc') },
];

export const childrenCasesPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenCustomerServicePageBreadcrumbs(navigate),
  { label: 'Casos', onClick: () => navigate('/atc/cases') },
];
export const childrenSettingsPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenCustomerServicePageBreadcrumbs(navigate),
  { label: 'Configurar', onClick: () => navigate('/atc/settings') },
];

export const childrenCasesInformationPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [...childrenCustomerServicePageBreadcrumbs(navigate)];
